export class ForgotPasswordRequest {
    userEmail: string = '';
    companyCode: string = '';
  }